var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightbulb = function SvgLightbulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    d: "M6.333 14.667h3.334m.333-4.45a4.667 4.667 0 1 0-4 0v.45c0 .621 0 .932.101 1.177.136.326.395.586.722.721.245.102.556.102 1.177.102s.932 0 1.177-.102c.327-.135.586-.395.722-.721.101-.245.101-.556.101-1.177z"
  })));
};
export default SvgLightbulb;